import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { JsonConvert } from 'json2typescript';
import { throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class WebApiService {
  private toastr: ToastrService | undefined
  constructor(private readonly injector: Injector) { }

  handleError(err: HttpErrorResponse) {
    if (!(this instanceof WebApiService)) {
      console.error('Handle error neobsahuje instanci WebApiService', err.error);
      return throwError(() => err);
    }

    this.toastr ??= this.injector.get(ToastrService); // lazy load kvůli kruhové závislosti

    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred.
      console.error('Došlo k chybě při HTTP požadavku:', err.message);
      this.toastr.error('Při zpracování požadavku došlo k chybě', err.message);
    } else {
      // The backend returned an unsuccessful response code.
      console.error(`Chyba, status ${err.status}, tělo požadavku: ${JSON.stringify(err)}`);
      let errorMessage = '';
      if (err.error?.title) {
        // exception from server
        err.error.exceptionLogged = true;
        errorMessage += ` ${err.error.title ?? ''} ${err.error.detail ?? ''}`.trim();
      } else {
        errorMessage += ` ${err.message ?? ''}`.trim();
      }
      this.toastr.error(`Status ${err.status} ${err.statusText}.${errorMessage}`, 'Při zpracování požadavku došlo k chybě.');
    }

    return throwError(() => err);
  }

  deserializeJson<T extends object>(json: object, classRef: new () => T): T {
    const converter = new JsonConvert();
    return converter.deserializeObject(json, classRef);
  }

  deserializeJsonArray<T extends object>(json: T[], classRef: new () => T): T[] {
    const converter = new JsonConvert();
    return converter.deserializeArray(json, classRef);
  }
}
